import { Flex, FlexProps, Text } from "@chakra-ui/react";
import { Spinner } from "@ui-kit/feedback/Spinner/Spinner.web";

type PageSpinnerProps = {
  lowOpacity?: boolean;
  spinnerText?: string;
} & FlexProps;

const PageSpinner = ({
  lowOpacity = false,
  spinnerText = undefined,
  ...props
}: PageSpinnerProps) => {
  return (
    <Flex
      id="page-spinner"
      data-testid="page-spinner"
      zIndex="spinner"
      opacity={lowOpacity ? "0.5" : "1"}
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      flexGrow={1}
      backgroundColor="gray.200"
      {...props}
    >
      <Spinner
        color="primary.600"
        emptyColor="gray.400"
        speed="0.65s"
        size="3xl"
        thickness="10px"
      />
      <Text
        hidden={!spinnerText}
        color="font.dark"
        mt="2xl"
        fontWeight="bold"
        fontSize="xl"
      >
        {spinnerText}
      </Text>
    </Flex>
  );
};

export default PageSpinner;
